import { useNavigate } from '@solidjs/router'
import { type Component, createMemo } from 'solid-js'
import { twMerge } from 'tailwind-merge'
import Icon from '~/components/Icon'
import type { GoBackPropsType } from '~/types/GoBack'

const GoBack: Component<GoBackPropsType> = props => {
  const navigate = useNavigate()

  const buttonClasses = createMemo(() => twMerge('group flex items-center text-sm font-medium transition-all duration-200', props.class || ''))

  const handleGoBack = () => {
    if (props.onClick) {
      props.onClick()
      return
    }

    if (window.history.length > 1) {
      navigate(-1)
    } else if (props.fallbackPath) {
      navigate(props.fallbackPath)
    }
  }

  return (
    <button type="button" onClick={handleGoBack} class={buttonClasses()}>
      <span class="flex items-center justify-center w-8 h-8 mr-2 text-gray-500 bg-surface-muted rounded-full group-hover:bg-primary-100 group-hover:text-primary-600 dark:text-gray-300 dark:group-hover:bg-primary-900 dark:group-hover:text-primary-400 transition-all duration-200">
        <Icon icon="material-symbols-light:arrow-back" size={20} />
      </span>
      <span class="text-foreground-muted group-hover:text-primary">{props.label || 'Volver'}</span>
    </button>
  )
}

export default GoBack
